import React, { Component } from "react";

import { HashLoader }  from 'react-spinners';

import { Container, Row , Col, Modal } from "react-bootstrap";

export default class Loading extends Component {

  constructor(props){
    super()
    this.data = props
  }

  handleHide = () => {
    return false
  }

  render(){
      return (
        <div className='isLoading'>
          {console.log('propsModal', this.data)}
        <style
        dangerouslySetInnerHTML={{
            __html: `
            .modal-dialog .modal-content {
              background-color: black !important;
              opacity: 0.9 !important
            }`
        }}
      />
        <Modal 
          show={true} 
          onHide={this.handleHide} 
          centered 
          id='isLoading'
          dialogClassName="isLoading"
        > 
          <Modal.Body>
            <Container style={{ marginTop: '25%' }}>
              <Row className="justify-content-center">
                <Col className="justify-content-center" style={{ display: 'contents' }}>
                  <HashLoader
                    size={150}
                    color={"#35bce4"}
                    loading={true}
                    style={{ margin: '50px' }}
                  />
                </Col>
              </Row>
            </Container>
          </Modal.Body>
        </Modal>
      </div>
    )
  }
} 